export default '2.1.0';



// WEBPACK FOOTER //
// ./src/lib/version.js